export const KEYBOARD_SHORTCUTS = {
  MARKET_ORDER_BUY: 'marketOrderBuy',
  MARKET_ORDER_SELL: 'marketOrderSell',
  LIMIT_ORDER_BUY: 'limitOrderBuy',
  LIMIT_ORDER_SELL: 'limitOrderSell',
  SUBMIT_ORDER: 'submitOrder',
  TOGGLE_CHART_ORDERS: 'toggleChartOrders',
  TOGGLE_QUICK_TRADE: 'toggleQuickTrade',
  OPEN_CONDITIONAL_ORDER: 'openConditionalOrder',
  TOGGLE_CHART_FULLSCREEN: 'toggleChartFullscreen',
  DRAW_TRENDLINE: 'drawTrendline',
  DRAW_HORIZONTAL_LINE: 'drawHorizontalLine',
  DELETE_SELECTED_DRAWING: 'deleteSelectedDrawing',
  CANCEL_DRAWING: 'cancelDrawing',
}
